export default "__VITE_ASSET__AC7tvpQv__"